import React from 'react'
import Icons from '../../../components/Icons'
import Image from '../Image/Image'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import {fetchEmployee} from '../../../utils/employees'
import styled from 'styled-components'
import {useViewFetch} from '../../../utils/fetch'
import {
  getAvailableActions,
  useConfigState
} from '../../../context/ConfigContext'

const initialState = {
  nameFirst: '',
  nameLast: '',
  email: '',
  emTitle: '',
  phone: '',
  rmId: '',
  blName: '',
  dpName: '',
  url: '',
  emName: ''
}
const Employee = ({emId, isDashboardView, requestSpaceChange}) => {
  const localeState = useLocaleState()
  const configState = useConfigState()
  const {moverequest} = getAvailableActions(configState)
  const {data: employee} = useViewFetch({
    api: fetchEmployee,
    parameters: {emId},
    onChangeOf: [emId],
    initialState
  })

  const {
    nameFirst,
    nameLast,
    email,
    emTitle,
    phone,
    rmId,
    blName,
    dpName,
    url,
    emName
  } = employee

  let employeeName = nameLast ? `${nameFirst} ${nameLast}` : emName

  return (
    <StyledContainer>
      <StyledImageContainer>
        <Image url={url} placeholder imageType="employee" />
      </StyledImageContainer>

      <StyledTitle>
        <StyledName>{employeeName}</StyledName>
        <StyledTitleText>{emTitle}</StyledTitleText>
      </StyledTitle>

      <StyledEmailContainer>
        <StyledDetailContainer>
          <div style={{width: 30}}>
            <Icons icon="PHONE" />
          </div>
          <StyledEmailText>{phone}</StyledEmailText>
        </StyledDetailContainer>

        <StyledDetailContainer>
          <div style={{width: 30}}>
            <Icons icon="EMAIL" />
          </div>
          <StyledEmailText>{email}</StyledEmailText>
        </StyledDetailContainer>
      </StyledEmailContainer>

      <StyledDepartmentContainer>
        <StyledDetailContainer>
          <div style={{width: 30, display: 'flex', alignItems: 'center'}}>
            <Icons icon="LOCATION" />
          </div>

          <div>
            <StyledDepartmentText>
              {dpName} - {rmId}
            </StyledDepartmentText>
            <StyledLocation>{blName}</StyledLocation>
          </div>
        </StyledDetailContainer>
      </StyledDepartmentContainer>

      {moverequest &&
        isDashboardView && (
          <StyledButtonContainer>
            <StyledButton onClick={() => requestSpaceChange({employee})}>
              {_L({key: 'Request Move', localeState})}
            </StyledButton>
          </StyledButtonContainer>
        )}
    </StyledContainer>
  )
}

export default Employee

const StyledContainer = styled.div`
  min-height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 228px 90px 90px 80px 80px;
  grid-template-columns: 320px;
  grid-template-areas: 'image' 'title' 'email' 'department' 'button';
  box-sizing: border-box;
  background-color: white;

  @media (max-width: 1024px) {
    grid-template-rows: 176px 80px 80px 80px 100px;
    grid-template-columns: 255px;
  }

  @media (max-width: 768px) {
    height: 150px;
    width: 100%;
    grid-template-rows: 75px 75px;
    grid-template-columns: 150px 275px 1fr;
    grid-template-areas: 'image title department' 'image email button';
  }

  @media (max-width: 420px) {
    height: 192px;
    width: 100%;
    grid-template-rows: 58px 67px 67px;
    grid-template-columns: 58px auto;
    grid-template-areas: 'image title' 'email email' 'department department';
  }
`

const StyledImageContainer = styled.div`
  padding: 0;
  margin-top: 48px;
  width: 320px;
  height: 180px;
  grid-area: image;
  box-sizing: border-box;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    width: 255px;
    height: 150px;
    margin-top: 26px;
  }

  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
    margin-top: 0;
  }

  @media (max-width: 420px) {
    width: 58px;
    height: 58px;
    box-sizing: border-box;
    margin-top: 0;
  }
`

const StyledTitle = styled.div`
  grid-area: title;
  box-sizing: border-box;
  margin: 0;
  padding: 19px 19px 19px 24px;
  border-bottom: 1px solid #f3f5fb;
  text-align: center;

  @media (max-width: 768px) {
    margin: 19px 0 0 0;
    padding: 0 0 0 24px;
    border-right: 1px solid #f3f5fb;
    border-bottom: 0;
    text-align: left;
  }

  @media (max-width: 420px) {
    margin: 0;
    padding: 9px 50px 9px 14px;
    border-bottom: 1px solid #f3f5fb;
    border-right: 0;
  }
`

const StyledText = styled.div`
  font-size: 16px;
  font-weight: normal;
  letter-spacing: -0.3px;
`

const StyledName = styled(StyledText)`
  font-size: 22px;
  font-weight: bold;
  color: black;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 420px) {
    font-size: 16px;
  }
`

const StyledTitleText = styled(StyledText)`
  color: #a4a9b7;

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 420px) {
    font-size: 12px;
  }
`

const StyledEmailContainer = styled.div`
  grid-area: email;
  box-sizing: border-box;
  margin: 0;
  padding: 19px 19px 19px 24px;
  border-bottom: 1px solid #f3f5fb;

  @media (max-width: 768px) {
    margin: 0 0 19px 0;
    padding: 8px 0 0 24px;
    border-right: 1px solid #f3f5fb;
    border-bottom: 0;
  }

  @media (max-width: 420px) {
    margin: 0;
    padding: 9px 15px 9px 15px;
    border-bottom: 1px solid #f3f5fb;
    border-right: 0;
  }
`

const StyledDetailContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
`

const StyledEmailText = styled(StyledText)`
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  padding-left: 6px;
`

const StyledDepartmentContainer = styled.div`
  grid-area: department;
  box-sizing: border-box;
  padding: 19px 19px 19px 24px;

  @media (max-width: 420px) {
    margin: 0;
    padding: 12px 15px 9px 15px;
    border-bottom: 0;
  }
`

const StyledDepartmentText = styled(StyledText)`
  font-weight: 600;
  font-size: 14px;
  color: #3395fe;
`

const StyledLocation = styled(StyledText)`
  font-size: 14px;
  color: #a5aab8;
`

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  grid-area: button;
`

const StyledButton = styled.button`
  width: 85%;
  height: 48px;
  border-radius: 6px;
  background-color: #f3f5fb;
  border: 2px solid #f3f5fb;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  color: #a4a9b7;
  cursor: pointer;
`
